import { useEffect, useState } from "react";

import { QuizStepProps } from "../useQuestionnaire";

import { Option } from "./components/Option";

const optionList = [
  { name: "<60 beats per minute (Slow)", value: "Slow" },
  { name: "60-100 beats per minute (Normal)", value: "Normal" },
  { name: "101-110 beats per minute (Slightly Fast)", value: "SlightlyFast" },
  { name: ">110 beats per minute (Fast)", value: "Fast" },
];

export const HeartRate = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("HeartRate", value);
    setLastUpdate({ key: "HeartRate", value });
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="pb-8 font-serif text-h3">
        What is your current or average resting heart rate range??
      </div>
      <div>
        <div className="flex flex-wrap gap-3" key="HeartRate">
          {optionList.map((option) => {
            return (
              <Option
                key={option.value}
                name={option.name}
                value={option.value}
                checked={props.data.HeartRate === option.value}
                onChange={(e) => handleChange(option.value)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
